import * as React from "react";
import "./styles/Button.scss";

interface Props {
    onClick: (id: number) => void;
    id?: number;
    title: string;
    style?: object;
    enabled?: boolean;
}


const Button: React.FC<Props> = ({id, onClick, title, style, enabled}) => {
    if(enabled == undefined) {
        enabled = true;
    }

    if(enabled) {
        return (
            <div style={style} className={"btn btn-cta btn-wide store-button"} onClick={() => {if(id !== undefined) {onClick(id)}}}>
                <span className={"title"}>{title}</span>
            </div>
        )
    } else {
        return (
            <div style={style} className={`${"store-button"} ${"disabled"}`}>
                <span className={"title"}>{title}</span>
            </div>
        )
    }
}

export default Button;